"use client";

import { useEffect } from "react";

import { useSession } from "@/lib/auth/client";
import { useSavedListings } from "@/lib/dao/SavedListingDao";

/**
 * Component that initializes the saved listings cache when the app loads
 * This ensures that the cache is available for all SavedListingButton components
 * without requiring them to individually trigger the cache initialization
 */
export function SavedListingsInitializer() {
  const { data: session } = useSession();
  const user = session?.user;
  const { refetch } = useSavedListings();

  // Initialize saved listings cache when user is authenticated
  useEffect(() => {
    if (user?.id) {
      // Trigger a refetch to ensure the cache is populated
      // This is a no-op if the cache is already populated
      refetch().catch((error) => {
        console.error("Failed to initialize saved listings cache:", error);
      });
    }
  }, [user?.id, refetch]);

  // This component doesn't render anything
  return null;
}
